import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonCol, IonRow, IonText } from '@ionic/angular/standalone';

import { DeviceDetectorService } from 'ngx-device-detector';
import { PuzzleHelpDialogInjectableInterface } from 'projects/tools/src/lib/shared-module/puzzle-help-dialog/puzzle-help-dialog-injectable.interface';
import { CrosswordBoardConfig } from '../crossword-board/crossword-board.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-swedish-help',
  templateUrl: './crossword-help.component.html',
  styleUrls: ['./crossword-help.component.scss'],
  standalone: true,
  imports: [CommonModule, IonCol, IonRow, IonText, TranslateModule],
})
export class CrosswordHelpComponent implements PuzzleHelpDialogInjectableInterface {
  public hideWarning = false;
  public crosswordBoardConfig: CrosswordBoardConfig;
  public data: CrosswordBoardConfig;

  public isDesktop: boolean;
  public isSafari: boolean;
  public isIOS: boolean;

  public device: string;
  public browser: string;

  public categories = [];

  constructor(private deviceService: DeviceDetectorService) {
    this.device = deviceService.isDesktop() ? 'desktop' : 'mobile';
    this.browser =
      this.device === 'desktop'
        ? deviceService.browser === 'Safari'
          ? 'safari'
          : 'other'
        : deviceService.os === 'Mac' || deviceService.os === 'iOS'
        ? 'ios'
        : 'android';

    this.isDesktop = deviceService.isDesktop();
    this.isSafari = deviceService.browser === 'Safari';
    this.isIOS = deviceService.os === 'Mac' || deviceService.os === 'iOS';
  }

  setData(data: CrosswordBoardConfig): void {
    this.data = data;

    this.categories = ['play', 'zoom', 'move', 'direction_change'];

    switch (data.crosswordSidebar) {
      case 'wordList':
        this.categories.push('word_list');
        this.categories.push('drag_drop');
        break;
      case 'definList':
      case 'definAccordion':
        this.categories.push('defin_list');
        break;
    }
  }
}
